const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                    ['extra', [this, 'block_extra']],
                    ['content', [this, 'block_content']]
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.startOutputBuffer();
                this.echo(`  `);
                this.traceableDisplayBlock(2, this.source)('extra', context.clone(), blocks);
                context.proxy[`_extra_content`] = (() => {let tmp = this.getAndCleanOutputBuffer(); return tmp === '' ? '' : new this.Markup(tmp, this.env.getCharset());})();
                this.echo(`
<span class="c-badge`);
                if ((context.has(`class`) ? context.get(`class`) : null)) {
                    this.echo(` `);
                    this.echo(this.env.getFilter('escape').traceableCallable(11, this.source)(...[this.env, (context.has(`class`) ? context.get(`class`) : null), `html`, null, true]));
                }
                this.echo(`">
  `);
                if (this.env.getFilter('trim').traceableCallable(12, this.source)(...[(context.has(`_extra_content`) ? context.get(`_extra_content`) : null)])) {
                    this.echo(`    <span class="c-badge__extra">
      `);
                    this.echo(this.env.getFilter('escape').traceableCallable(14, this.source)(...[this.env, (context.has(`_extra_content`) ? context.get(`_extra_content`) : null), `html`, null, true]));
                    this.echo(`
    </span>
  `);
                }
                this.echo(`  <span class="c-badge__content">
    `);
                this.traceableDisplayBlock(18, this.source)('content', context.clone(), blocks);
                this.echo(`  </span>
</span>
`);
            }

            block_extra(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    `);
                if ((context.has(`icon`) ? context.get(`icon`) : null)) {
                    this.echo(`      `);
                    this.echo(this.include(context, this.source, `@cloudfour/components/icon/icon.twig`, new Map([[`name`, (context.has(`icon`) ? context.get(`icon`) : null)]]), false, false, 4));
                    this.echo(`    `);
                }
                this.echo(`  `);
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`      `);
                this.echo(this.env.getFilter('escape').traceableCallable(19, this.source)(...[this.env, (((context.has(`label`))) ? (this.env.getFilter('default').traceableCallable(19, this.source)(...[(context.has(`label`) ? context.get(`label`) : null), `Label`])) : (`Label`)), `html`, null, true]));
                this.echo(`
    `);
            }

            getTemplateName() {
                return `09e4ff157be4af63958ee4d5a5897ae0261ff2a81469e6d8486cbeb952fac8ef`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `09e4ff157be4af63958ee4d5a5897ae0261ff2a81469e6d8486cbeb952fac8ef`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, '09e4ff157be4af63958ee4d5a5897ae0261ff2a81469e6d8486cbeb952fac8ef');

let template = env.loadTemplate('09e4ff157be4af63958ee4d5a5897ae0261ff2a81469e6d8486cbeb952fac8ef');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/components/badge/badge.twig", args: context }
     );
     return rendered;;
};